import Vue from 'vue'
import Vuetify, {
  VCard,
  VRating,
  VToolbar
} from 'vuetify/lib'
import { Ripple } from 'vuetify/lib/directives'
import RelateIcon from '@/components/elements/RelateIcon.vue'
import RefreshIcon from '@/components/elements/RefreshIcon.vue'
import BankDataIcon from '@/components/elements/BankDataIcon.vue'
import OpenDialogIcon from '@/components/elements/OpenDialogIcon.vue'
import CalendarIcon from '@/components/elements/CalendarIcon.vue'

Vue.use(Vuetify)

export default new Vuetify({
  components: {
    VCard,
    VRating,
    VToolbar
  },
  directives: {
    Ripple
  },
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: '#01D28E',
        secondary: '#01BCD2',
        accent: '#82B1FF',
        error: '#D20124',
        info: '#01BCD2',
        success: '#01D28E',
        warning: '#FFC107'
      }
    }
  },
  icons: {
    iconfont: 'mdi',
    values: {
      relate: {
        component: RelateIcon
      },
      refresh: {
        component: RefreshIcon
      },
      bankData: {
        component: BankDataIcon
      },
      openDialog: {
        component: OpenDialogIcon
      },
      calendar: {
        component: CalendarIcon
      }
    }
  }
})
